module.exports = __webpack_public_path__ + "static/media/spot3.8da3c7f7.png";